import dentalCorpBackend from './dentalCorpBackend';
import { purgeState } from '../../actions/commonActions';
import { redeemSession } from '../../actions/commonActions';

let DentalCorpBackend = new dentalCorpBackend();

let lastRedeemCallAt = new Date().getTime() - 60 * 1000;

const hasRedeemedSessionRecently = () => {
	return new Date().getTime() - lastRedeemCallAt < 30000;
};

let apiMethods = {};

const getInstanceMethodNames = (obj) => {
	const proto = Object.getPrototypeOf(obj);
	const names = Object.getOwnPropertyNames(proto);
	return names.filter((name) => typeof obj[name] === 'function' && obj[name] !== 'constructor');
};

let debounceTracker = {};

const debounceConfig = {};

getInstanceMethodNames(DentalCorpBackend).forEach((methodName) => {
	apiMethods[methodName] = async (...args) => {
		try {
			let debounceMillis = debounceConfig[methodName];
			if (debounceMillis) {
				callDebounced(methodName, args, debounceMillis);
			} else {
				return await DentalCorpBackend[methodName](...args);
			}
		} catch (e) {
			console.log(JSON.stringify(e));
			if (e.code === 1001 || e.status === 401) {
				let dispatch = args[args.length - 1];
				console.log('checking ', args);
				let sessiontoken = args[0].session.session_token;
				console.log('Call REDEEM SESSION', sessiontoken);
				if (sessiontoken && !hasRedeemedSessionRecently()) {
					lastRedeemCallAt = new Date().getTime();
					dispatch(redeemSession(sessiontoken));
				} else {
					dispatch(purgeState());
				}

				if (methodName === 'redeemSession') {
					dispatch(purgeState());
				}
			} else {
				return null;
			}
		}
	};
});

const callDebounced = (methodName, args, debounceMillis) => {
	let setTimeoutID = debounceTracker[methodName];
	if (setTimeoutID) {
		clearTimeout(setTimeoutID);
	}
	setTimeoutID = setTimeout(() => {
		DentalCorpBackend[methodName](...args);
	}, debounceMillis);
	debounceTracker[methodName] = setTimeoutID;
};

export const getDentalCorpBackend = () => {
	return apiMethods;
};

export const setBaseUrl = async host => {
  DentalCorpBackend.setBaseUrl(host);
};